/**
 * LiveStreamingWatchersStat — the live watcher-count pill.
 *
 * Web port of the Flutter `_watchersStats` app-bar action
 * (`lib/presentation/screens/community/live_streaming_screen.dart:1089-1132`): an
 * eye icon (`assets/images/eye.png`, white-tinted) + the live watcher count, in
 * a rounded translucent pill. Both roles display it (`:1086`). The pill markup
 * now lives in the shared `LiveStreamingStatPill` shell (Task 5), which the
 * near-twin `LiveStreamingCoinsStat` (`_coinsStats`, `:1134-1176`) also
 * delegates to.
 *
 * Placement + visibility gating live on the page: Flutter shows the stats only
 * when `_firstFrameRendered && !_clearScreen && !_liveStreamingEnded
 * && !_isOpeningChannel` (`:1079-1084`), so this component neither re-derives
 * that gate nor positions itself.
 *
 * The watcher count is shown raw (Flutter `"$watchers"`, `:1119`), unlike the
 * coins pill which formats via `getReactionsIntlNumber`. `data-qa-value` carries
 * the count so QA can assert it.
 */

import React from 'react';

import { useTheme } from '@/presentation/contexts/ThemeContext';
import { LiveStreamingStatPill } from './LiveStreamingStatPill';

export interface LiveStreamingWatchersStatProps {
  /** The live watcher count (`_watchersValueNotifier`, `:1116`). */
  watchers: number;
}

export const LiveStreamingWatchersStat: React.FC<
  LiveStreamingWatchersStatProps
> = ({ watchers }) => {
  const { theme } = useTheme();

  return (
    <LiveStreamingStatPill
      iconPath="/assets/images/eye.png"
      iconColor={theme.white}
      value={watchers}
      qaId="live-streaming-watchers"
      qaValue={watchers}
    />
  );
};
